<template>
  <v-flex shrink :style="{'width': $attrs['container-width'], 'text-align': $attrs['text-align'] || 'center'  }">
    <img v-if="logoSrc" :src="logoSrc" alt="askod online logo" :style="{'width': $attrs.width }" />
  </v-flex>
</template>

<script>
import get from 'lodash/get';
import { actions } from '@/models/store.actions';
export default {
  name: 'Logo',
  inject: ['baseUrl'],
  data() {
    return {
      logoSrc: ''
    };
  },
  async created() {
    let appSettings = await this.$store.getters[actions.SETT_GET_STG_WAITER];
    const systemName = get(appSettings, 'systemName') || 'askod_online';
    this.logoSrc = `${this.baseUrl}static/${systemName}_logo.svg`;
  }
};
</script>
